import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail } from 'lucide-react';
import RequestAccessModal from './RequestAccessModal';

const CTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogin = () => {
    window.location.href = 'https://app.alpenglowstudio.net';
  };

  const handleRequestAccess = () => {
    setIsModalOpen(true);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-[#1a4d4d] via-[#0f3a3a] to-[#0a2e2e] relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#8b956d]/10 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Sword Icon from Logo */}
        <div className="flex justify-center mb-8">
          <div className="px-8 py-6 bg-[#8b956d]/20 rounded-2xl flex items-center justify-center border-2 border-[#8b956d]/40">
            <img
              src="https://customer-assets.emergentagent.com/job_excalibur-login/artifacts/xx3h8d4i_Excalibur.png"
              alt="Excalibur"
              className="h-20 w-auto"
            />
          </div>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#c5c9b8] mb-6 font-['Cinzel']">
          Ready to Wield Excalibur?
        </h2>
        <p className="text-lg md:text-xl text-[#b5bca0] mb-12 max-w-2xl mx-auto leading-relaxed">
          Join the ranks of businesses leveraging the legendary power of Excalibur CRM. Access your account or request a demo today.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Button
            onClick={handleLogin}
            size="lg"
            className="bg-[#8b956d] hover:bg-[#9ca878] text-[#0a2e2e] font-bold text-lg px-10 py-7 rounded-lg transition-all duration-300 hover:shadow-2xl hover:shadow-[#8b956d]/40 hover:scale-110 group"
          >
            <span>Access Your CRM</span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
          </Button>
          <Button
            onClick={handleRequestAccess}
            size="lg"
            variant="outline"
            className="border-2 border-[#8b956d] text-[#c5c9b8] hover:bg-[#8b956d]/10 font-semibold text-lg px-10 py-7 rounded-lg transition-all duration-300 hover:shadow-xl hover:scale-110 group"
          >
            <Mail className="mr-2 w-5 h-5" />
            <span>Request Access</span>
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 pt-12 border-t border-[#8b956d]/20">
          <p className="text-sm text-[#8b956d] uppercase tracking-wider font-semibold mb-6">
            Powered by Industry-Leading Technology
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="text-[#c5c9b8] opacity-60 hover:opacity-100 transition-opacity duration-300">
              <span className="font-semibold">GoHighLevel</span>
            </div>
            <div className="w-1 h-1 bg-[#8b956d]/50 rounded-full"></div>
            <div className="text-[#c5c9b8] opacity-60 hover:opacity-100 transition-opacity duration-300">
              <span className="font-semibold">Cloud Infrastructure</span>
            </div>
            <div className="w-1 h-1 bg-[#8b956d]/50 rounded-full"></div>
            <div className="text-[#c5c9b8] opacity-60 hover:opacity-100 transition-opacity duration-300">
              <span className="font-semibold">AI-Powered</span>
            </div>
          </div>
        </div>
      </div>

      {/* Request Access Modal */}
      <RequestAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default CTA;
